export default __webpack_public_path__ + "static/media/ate3.7e6e720d.png";